export default "__VITE_ASSET__Pw8tIAOL__"